import React, {useState, useContext, useEffect, useRef, Fragment } from 'react';
import "../../ui-styles/list/AttachmentList.css";
import "../../ui-styles/fileView/FileView.css";
import "../../ui-styles/cards/Prescription.css";
import "../../ui-styles/prescription/prescriptionAdd.css"
import "../../ui-styles/sliders/RightFullSlider.css";
import "../../ui-styles/buttons/IconButton.css";
import "../../ui-styles/animations/ripple.css";
import "../../ui-styles/buttons/ButtonFilled.css";
import "../../ui-styles/buttons/ButtonTxt.css";
import "../../ui-styles/bottomSlider/BottomDetailsSlide.css";
import "../../ui-styles/sliders/RightChildSlider.css";
import "../common/fileUploads/uploadsStyles.css";
import "../../ui-styles/tooltips/tooltips.css";
import { dateFormat, getExperience } from "../../lib/functions";
import { LangCtx, SpecializationsCtx} from "../../lib/context";
import Loader from "../../lib/ui/loader/Loader";
// import config from '../../config.json';
import { Document, Page } from 'react-pdf';
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';

import DrugRow from "../conference/components/DrugRow";
// import PdfView from "./pdfView";
// import { getPrescription, createPrescription, updatePrescription, prescriptiondelete } from "../../actions/schedule";
import { getPrescription } from "../../actions/schedule";
import { useParams } from 'react-router-dom';
import { getappointment, getDoctorSignature } from '../../actions/appointment';
import { toast } from 'react-toastify';
import NoData from '../../lib/ui/nodata/NoData';
import queryString from 'query-string';
import { langObj } from "../../locale/index";
// import { getDegree, getDepartmentList, getSpecialization } from '../../actions/configuration';
import {API} from 'aws-amplify';


const OpenPrescription = (props) => {
    const { l, setLang } = useContext(LangCtx);
    // const { departments } = useContext(DepartmentsCtx);
    const { id } = useParams();
    // const imageTypes = ['image/gif', 'image/jpeg', 'image/jpg', 'image/png'];
    const [loading, setLoading] = useState(false);
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);
    const contentRef = useRef();
    const [errorMsg, setErrorMsg] = useState('');
    const [prescription, setPrescription] = useState(null)
    const [appmntData, setAppmntData] = useState(null)
    const [uploadedData, setUploadedData] = useState({});
    //  const {prescription, appmntData, uploadedData} = props;

    const { specializationsList } = useContext(SpecializationsCtx);

    const loadSpec = (spec) => {
        if (specializationsList) {
            let specList = Object.values(specializationsList).flat(1);
            let _spec = specList.filter(itm => itm.value === spec);
            return _spec && _spec[0] && _spec[0][l.locale] ? _spec[0][l.locale] : ' - ';
        } else {
            return "";
        }
    }


    useEffect(() => {
        if (id && id !== "") {
            setLoading(true)
            const query_data = queryString.parse(props.location.search);
            if (query_data && query_data.lang && query_data.lang !== "") {
                setLang(langObj[query_data.lang]);
                localStorage.setItem('lang', query_data.lang);
            }
            getappointment(id).then(res => {
                setLoading(false);
                if (res.status) {
                    setAppmntData(res.data);
                    getPrescription(id).then((res) => {

                        if (res && res.status) {
                            //  setLoading(false);
                            setPrescription(res.data);

                        }
                    }).catch(err => {
                        setLoading(false);
                        console.log(err.response)
                        //  setLoading(false);
                    })
                    getDoctorSignature(res.data.doctorId).then(res => {
                        setLoading(false);
                        if (res.status && res.data.length > 0) {
                            setUploadedData(res.data)
                        }
                    }).catch(err => {
                        setLoading(false);
                        toast.error(err.errorMessage, {
                            position: toast.POSITION.TOP_RIGHT
                        })
                        console.log("err ==== ", err);
                    })
                } else {
                    //  history.push("/");
                }
            }).catch(err => {
                console.log("err ==== ", err);
                if(API.isCancel(err)) {
                    console.log("API is canceled................");
                } else {
                    setLoading(false);
                }
                //history.push("/");
            })

            // getPrescriptionById(id).then(res => {
            //     setLoading(false)
            //     setPrescription(res.data);
            //     setAppmntData(res.appointmentData)
            //     setOpenPresc(true);
            // }).catch(err => {
            //     setOpenPresc(true);
            //     setLoading(false)
            //     let msg = err?.response?.data ? err.response.data.error : l.unable_upd_patient;
            //     setErrorMsg(msg);
            // });
        } else {
            setErrorMsg(l.ent_presc_id)
        }
    }, [id])

    const backgroundColor = {
        backgroundColor: '#2b80c4'
    }
    const footerColor = {
        backgroundColor: '#68D195'
    }
    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages)
    }

    const prevClick = () => {
        setPageNumber(prevState => prevState - 1)

    }

    const nextClick = () => {
        setPageNumber(prevState => prevState + 1)

    }
    let cls = props.openSlide ? "middlePrescription rightSliderIn" : "middlePrescription";
    // cls += props.type !== "view" ? " fullSlide" : "";
    cls += props.type !== "view" ? "" : "";

    let header = null, footer = null, sign = null;

    for (let i in uploadedData) {
        let item = uploadedData[i];
        switch (item.uploadtype) {
            case "header": header = item;
                break;
            case "signature": sign = item;
                break;
            case "footer": footer = item;
                break;
            default: break;
        }
    }
    return (
        loading ? <Loader /> : <div className="btmDtlSlider visible">
            <div className={cls}>
                <div className="rightSliderHdr">
                    <div className="hdrRowBlock">
                        {errorMsg && errorMsg !== "" && <div className="errorBox">
                            <small className="errorTxt">{errorMsg}</small>
                        </div>
                        }
                        <div className="hdrTitleBox">

                            <span>{l.presc}</span>
                        </div>
                        <div className="hdrActionGroup">
                            {prescription && prescription !== null ?

                                <div className="prescTitleAction">

                                    <div tooltip="Print" flow="down">
                                        <ReactToPrint content={() => contentRef.current}>
                                            <PrintContextConsumer>
                                                {({ handlePrint }) => (
                                                    <div className="iconBtnBlock primary Sm ripple" onClick={handlePrint}>
                                                        <img src="/images/icons/printing.png" alt="icon" className='invertPrimary'/>
                                                    </div>
                                                )}
                                            </PrintContextConsumer>
                                        </ReactToPrint>

                                    </div>

                                </div>
                                : ''}
                            {/* <div className="hdrActItem close" onClick={closeSearchPresc}></div> */}
                        </div>
                    </div>
                </div>

                <div className="printPrescWrapper">
                    <div className="printPrescContainer" ref={contentRef}>
                        {(prescription && prescription!== null && appmntData && appmntData!==null) ?
                            prescription && prescription.prescriptionpath ?
                                <Fragment>
                                    <div className="mediaBdyCntnr pdngTB16">
                                        <div className="mediaBdy">
                                            <div className="mediaViewBox">
                                                <div className="mediaFileContainer">
                                                    {prescription && prescription.prescriptionpath && (prescription.prescriptionpath.type === "image/png" || prescription.prescriptionpath.type === "image/jpeg" || prescription.prescriptionpath.type === "image/jpg" || prescription.prescriptionpath.type === "image/x-png") ?

                                                        <img src={process.env.REACT_APP_api_server + '/api/uploads/prescription/' + prescription.prescriptionpath.key} alt="prescriptionfile" /> :
                                                        <Fragment>
                                                            <nav className="pdfControls">
                                                                {pageNumber > 1 && <button onClick={prevClick}>Prev</button>}
                                                                {numPages && pageNumber < numPages && <button onClick={nextClick}>{l.next}</button>}
                                                            </nav>
                                                            <Document file={process.env.REACT_APP_api_server + '/api/uploads/prescription/' + prescription.prescriptionpath.key} onLoadSuccess={onDocumentLoadSuccess}  >
                                                                <Page pageNumber={pageNumber} />
                                                                {Array.apply(null, Array(numPages))
                                                                    .map((x, i) => i + 1)
                                                                    .map(page => <Page pageNumber={page}></Page>)}
                                                            </Document>
                                                            <div className="pdfControls">
                                                                <p>Page {pageNumber} Page {numPages}</p>
                                                            </div>
                                                        </Fragment>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Fragment>
                                :
                                <Fragment>
                                    {/* <div className="printPrescHdr">

                            </div> */}
                                    <div className="printPrescBdy">
                                        {header ?
                                            <div className="prevPrescHdrBanner">
                                                <div className="prevPrescHdr">
                                                    <div className="prevPrescBranding prescHdFooter">
                                                        <img src={header.uploadurl} alt="logo" />
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            <div className="presBranding" style={backgroundColor}>
                                                <img src="/images/logos/logo.png" alt="logo" className="invertWhite" />
                                            </div>
                                        }
                                        <div className="printPrescBdyContent">
                                            <div className="prescDetailItem">
                                                <div className="presDtlBlock">
                                                    <span className="presTxtL">{l.pat_name} <small>{appmntData.patientData.firstName ? `${appmntData.patientData.firstName} ` : ''}{appmntData.patientData.lastName ? `${appmntData.patientData.lastName}` : ''}</small></span>
                                                    {/* <span className="presTxtL">{l.pat_name} <small>{appmntData.patientData.name ? `${appmntData.patientData.name} ` : ''}</small></span> */}
                                                    <span className="presTxtL">{l.pat_age} <small>{appmntData.patientData.dob ? `${getExperience(new Date(appmntData.patientData.dob), l)}` : ''}</small></span>
                                                    <span className="presTxtL">{l.pat_gender} <small>{appmntData.patientData.gender ? appmntData.patientData.gender : ''}</small></span>
                                                    <span className="presTxtL">{l.upload_date} <small>{appmntData.updatedAt ? dateFormat(appmntData.updatedAt) : ''}</small></span>
                                                </div>
                                                <div className="presDtlBlock txtRight">
                                                    <span className="presTxtL"><small>{`Dr. ${appmntData.doctorData.firstName ? appmntData.doctorData.firstName : ''} ${appmntData.doctorData.lastName ? appmntData.doctorData.lastName : ''}`}</small></span>
                                                    <span className="presTxtL">{appmntData.doctorData.speciality ? loadSpec(appmntData.doctorData.speciality) : ''}<small></small></span>
                                                </div>
                                            </div>
                                            <div className="prescDetailItem">
                                                <div className="presDtlBlock">
                                                    <span className="presTxtL">{l.reas_for_call}: <small>{appmntData.reason ? l[decodeURIComponent(appmntData.reason)] : ''}</small></span>
                                                    <span className="presTxtL">{l.det_by_pat} <small>{appmntData.description ? decodeURIComponent(appmntData.description) : ''}</small></span>
                                                </div>
                                            </div>
                                            <div className="prescDetailItem">
                                                <div className="presDtlBlock">
                                                    <span className="presTxtL">{l.chief_comp}:</span>
                                                    <span className="presTxtL"><small>{prescription.chiefComplaint}</small></span>
                                                </div>
                                                <div className="presDtlBlock">
                                                    <span className="presTxtL">{l.diagnosis}:</span>
                                                    <span className="presTxtL"><small>{l[prescription.diagnosis]}</small></span>
                                                </div>
                                            </div>
                                            <div className="prescDetailItem">
                                                <div className="presDtlBlock">
                                                    <span className="presTxtL">{l.investigation}:</span>
                                                    <span className="presTxtL"><small>{prescription.investigation}</small></span>
                                                </div>
                                                <div className="presDtlBlock">
                                                    <span className="presTxtL">{l.remarks}:</span>
                                                    <span className="presTxtL"><small>{prescription.remarks}</small></span>
                                                </div>
                                            </div>
                                            <div className="presMedGroup">
                                                <div className="prescTableWrapper">
                                                    <table className="prescTable">
                                                        <thead>
                                                            <tr>
                                                                <th>{l.s_no}</th>
                                                                <th>{l.drug_name}</th>
                                                                <th>{l.qtyd}</th>
                                                                <th>{l.schedule}</th>
                                                                <th>{l.note}</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {prescription.drugs.length > 0 && prescription.drugs.map((drug, i) =>
                                                                <DrugRow data={drug} key={i} index={i} />
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="printPrescFooter">
                                        <div className="signatureCol">
                                            <div className="signatureBox">
                                                <span className="docLTxt">{`Dr. ${appmntData.doctorData.firstName ? appmntData.doctorData.firstName : ''}${appmntData.doctorData.lastName ? appmntData.doctorData.lastName : ''}`}</span>
                                                {/* <span className="docSTxt capitalizeText">{appmntData.doctorData.qualification ? appmntData.doctorData.qualification : ""}
                                                    {appmntData.doctorData.department && departments[appmntData.doctorData.department] && departments[appmntData.doctorData.department][l.locale] ? ` - ${departments[appmntData.doctorData.department][l.locale]}` : ''}{appmntData.doctorData.serviceStartDate ? ` - ${getExperience(new Date(appmntData.doctorData.serviceStartDate), l)}` : ''}</span> */}
                                                    <span className="docSTxt capitalizeText">{appmntData.doctorData.qualification ? appmntData.doctorData.qualification : ""}
                                                    {appmntData.doctorData.department  ? ` - ${appmntData.doctorData.department}` : ''}</span>
                                                    <div className="signatureIcon">
                                                    {sign &&
                                                        <img src={sign.uploadurl} alt="logo" />}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="prevPrescFooter">
                                            {footer ?
                                                <div className="prevPrescBranding prescHdFooter">
                                                    <img src={footer.uploadurl} alt="logo" />
                                                </div>
                                                :
                                                <div className="prevPrescBranding prescHdFooter" style={footerColor}>
                                                    <img src="/images/logos/presc-footer.png" alt="logo" />
                                                </div>

                                            }
                                        </div>
                                    </div>
                                </Fragment>
                            :
                            <div className="prescriptionCard">
                                <div className="presCardBdy noPrescMsg">
                                    <NoData src="/images/icons/pending-appointments.png" label={l.no_presc_txt} />
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OpenPrescription;

